// Path: src\Components\HowToJoin\HowToJoin.jsx
import { React, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import howtojoin1 from '../../images/howtojoin1.png';
import howtojoin2 from '../../images/howtojoin2.png';
import howtojoin3 from '../../images/howtojoin3.png';
import howtojoin4 from '../../images/howtojoin4.png';
import Button from "../CommonFields/Button";
import BaseHome from '../Home/BaseHome';

import { howToJoinByGame } from "../../api/howToJoin.api";
import { url } from "../../config/url";
import ListLoader from '../Common/ListLoader';

const HowToJoin = ({ children, onBackClick }) => {
  const { t } = useTranslation();

  const gameId = localStorage.getItem("activeGameId");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true)
    fetchHowToJoin();
  }, [gameId])

  const fetchHowToJoin = async () => {
    try {
      const res = await howToJoinByGame({
        game: gameId
      });
      if (res?.success && res?.data) {
        setList(res?.data?.images)
      }
      else {
        setList([]);
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)

    }
  };

  return (
    <>
      <BaseHome title={t('how_to_join?')} onBackClick={onBackClick}>
        {list.length > 0 ? list.map((step, index) => (
          <div className="how-to-join-container" key={index}>
            <div className="how-to-join-step-description">
              {step.label}
            </div>
            {step.defaultImage &&
              <div className="step">
                <img src={url?.IMAGE_URL + step.defaultImage} alt={`Step ${index + 1}`} className="how-to-join-step-image" />
              </div>
            }
          </div>
        )) :!loading&&
          <> <div className='no-record-found-center-withone-header'><span className="text-center">{t('common.no_data_found')}</span></div></>
        }
        {loading && <div className='w-100 d-flex justify-content-center'> <ListLoader /></div>}

      </BaseHome>
    </>
  );
};

export default HowToJoin;
